export const sortByQuestionStatus = (questions) => {
  if (!questions || questions?.length === 0) return questions
  const compare = (a, b) => {
    if (a.answered === true && b.answered === false) {
      return 1
    }
    if (a.answered === false && b.answered === true) {
      return -1
    }
    return 0
  }
  return questions.sort(compare)
}
